// INFO: https://reactrouter.com/web/guides/scroll-restoration/scroll-to-top

export const scrollToTop = () => {
  window.scrollTo(0, 0);
};
